import { Theme } from "@remo-co/ui-core/src/types";

export const styles = {
  menuPopOver: {
    marginTop: 2,
    top: "52px !important",
    borderRadius: "5px",
    width: "350px",
    height: "auto",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    padding: "8px 10px",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 10px !important",
    backgroundColor: (theme: Theme) => theme.palette.events.grayShade2,
    height: "60px",
  },
  profileContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start !important",
    gap: "10px",
  },
  avatarContainer: {
    minWidth: 40,
    maxWidth: 40,
    maxHeight: 40,
    minHeight: 40,

    "& > span": {
      "& > div": {
        height: 40,
      },
    },
  },
  userInfoContainer: {
    width: 223,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 1,
  },
  profileName: {
    color: "text.primary",
  },
  editButton: {
    textDecoration: "none",
    padding: "6px",
    whiteSpace: "nowrap",
    cursor: "pointer",
    fontWeight: "500 !important",
    fontSize: 14,
    width: 47,
  },
  separator: {
    padding: "4px 8px",
    borderBottom: (theme: Theme) => `1px solid ${theme.palette.gray.light}`,
  },
  versionContainer: {
    padding: "6px 12px",
    textAlign: "right",
    alignItems: "center",
    borderTop: (theme: Theme) => `1px solid ${theme.palette.gray.light}`,
  },
  version: {
    color: (theme: Theme) => `${theme.palette.events.lightBlack} !important`,
  },
  text: {
    color: "text.primary",
  },
  menuItemsContainer: {
    margin: "5px auto",
  },
};
